/**
 * Created by Languagenut on 28/08/2019.
 */

import React  from 'react';
import {ListGroupItem, ListGroup,  Row , Col, Card} from 'react-bootstrap';
import CDNAudio from '../../audio';


export default class VerbContent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {

        };
    }

    isArabic(text){
        var arabicTestString = /[\u0600-\u06FF]/;
        return arabicTestString.test(text)
    }

    getVerbSection(verbObject) {

        return <Row>
            <Col sm={12} style={{fontSize:this.isArabic(verbObject.originalVerb) ? "16px" : null, textAlign:this.isArabic(verbObject.word) ? "right" : "left" }}><Card body><b>{verbObject.originalVerb}</b></Card></Col>
            <br/>
        </Row>


    }

    componentWillReceiveProps(props){

        this.props = props;
        this.setState({
            update:true,
        })

    }

    playAudio(path){
        (new CDNAudio(path)).play();
    }

    render() {
        if (this.props.verbTranslations == undefined) {
            return "";
        }

      /*  -- Remove Hint button in Vocab COULD ADD
        -- Multi assign Vocab, Verbs etc for quicker assignment process DONT THINK DONE
        -- Instant feedback for wrong answers NOT ADMIN
        -- Set pass limit to pass test or auto reassign if not achieved REMOVED
        -- My content – link not clear for students - rename NOT ADMIN
        -- School and Class Leader Board DONE
        -- Edit an assignment -- NOT IN CURENT VERSION ( EDIT )
        -- Recent Activity Report – add Login Time to Date DOING
        -- Add filter option on Assignments to sort completed DOING
        -- School Leader Board for Students DONE
        -- ADD COMMENT ONTO SUMMARY SCREEN ( overall)
        -- Checkbox on overview
        -- Sort*/






        var VocabObjects = [];
        let _alert = null;
        let _alertB = null;

        if(this.props.verbTranslations > 10)
        {
             _alert = <i>Students will be assigned 10  at random from the list below</i>
            _alertB = <i>Students will be assigned 10  at random from the list above</i>
        }
        for (var idx = 0 ; idx < this.props.verbTranslations.length; idx++) {
            VocabObjects.push(<Col md={6}>{this.getVerbSection(this.props.verbTranslations[idx])}</Col>);
        }
        return  <div>
                <div style={{padding:'20px'}}>
                    {_alert}
                    <Row className="p-t-10">
                        {VocabObjects}
                    </Row>
                    {_alertB}
                </div>
            </div>
    }

}